import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewComboLg = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M5.61 42.375V5.625H20.5v36.75zm21.86 0V5.625h14.89v36.75z" }), /* @__PURE__ */ _jsx("path", { d: "M5.61 42.375V5.625H20.5v36.75z" })]
});
export default SvgViewComboLg;
